var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('Audio',{staticClass:"audioClip",attrs:{"id":_vm.uniqueId,"autoplay":"","hidden":"","loop":_vm.loop}},[_c('source',{attrs:{"src":_vm.AudioClipSource,"type":"Audio/mpeg"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }